'use client';

import { useState, useRef, useEffect } from 'react';

var useClickOutSide = function (initState, options) {
    var callback = (options || {}).callback;
    var _a = useState(initState), isVisible = _a[0], setElementVisible = _a[1];
    var elementRef = useRef(null);
    var handleKeyDropdown = function (e) {
        if (e.key === 'Escape') {
            setElementVisible(false);
        }
    };
    var handleClickOutSide = function (e) {
        if (elementRef.current && !elementRef.current.contains(e.target) && isVisible) {
            setElementVisible(false);
            callback && callback();
        }
    };
    useEffect(function () {
        document.addEventListener('keydown', handleKeyDropdown);
        document.addEventListener('click', handleClickOutSide);
        return function () {
            document.removeEventListener('keydown', handleKeyDropdown);
            document.removeEventListener('click', handleClickOutSide);
        };
    }, [isVisible]);
    return { elementRef: elementRef, isVisible: isVisible, setElementVisible: setElementVisible };
};

export { useClickOutSide as default };
//# sourceMappingURL=useClickOutSide.js.map
